export default __webpack_public_path__ + "static/1-412fbf25845cd5199f4cd1afb8c51797.jpeg";